
// @ts-nocheck
declare var gGDPR_logoURL: string;

declare var gGDPR_privacyPolicyURL: string;

import { Emit, Component, Prop, Vue } from "vue-facing-decorator";
import SensitiveDataList from './SensitiveDataList.vue';
import ConsentItem from './ConsentItem.vue';

import { UsVaV1 } from '@iabtcf/gpp/encoder/section/UsVaV1.js'; 

@Component({
  components: {
    SensitiveDataList,
    ConsentItem
  },
  props: {
    cmpApi: Object,
  },  

})

export default class LayerStateVirginia extends Vue {

	privacyPageURL = "";
  forcedFixedPosition = false;
  logo_URL = typeof gGDPR_logoURL  == "string" ? gGDPR_logoURL : "";

  consentToSharing = true;
  consentToTargeting = true;
  sectionName = UsVaV1.NAME
  sectionID = UsVaV1.ID
  dirty = false

	mounted(): void {
    console.log("Virginia Mounted");
    this.privacyPageURL = typeof gGDPR_privacyPolicyURL  == "string" ? gGDPR_privacyPolicyURL : "";

    if ( this.cmpApi.hasSection( this.sectionName ) ) {
          this.consentToSharing = this.cmpApi.getFieldValue(this.sectionName, 'SaleOptOut' ) == 2  ? true : false;
          this.consentToTargeting = this.cmpApi.getFieldValue(this.sectionName, 'TargetedAdvertisingOptOut') == 2  ? true : false;
        }
      else  {
        this.updateCMP( true );
      }
	}

  sensitiveDataChange( consentArray: any ) {
    console.log("LayerStateVirginia: sensitiveDataChange(): event=", consentArray);
    this.dirty = true;
  } 

  updateCMP( consentToAll ) {
    console.log("LayerStateVirginia: updateCMP() consentToAll=" + consentToAll );

    //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsVaV1Field.ts

    //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsVaV1.ts

    //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/VA/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20Virginia%20Privacy%20Technical%20Specification.md

    let sections = this.cmpApi.getApplicableSections();

      if ( sections.indexOf( this.sectionID) == -1 ) {
        sections.push( this.sectionID );
        this.cmpApi.setApplicableSections(sections);
      }

      if ( consentToAll ) {
        this.consentToSharing = true;
        this.consentToTargeting = true;
        this.cmpApi.setFieldValue(this.sectionName, 'SensitiveDataProcessing',  Array( 8 ).fill( 2 ) );
      }

    this.cmpApi.setFieldValue(this.sectionName, 'Version', 1);
    this.cmpApi.setFieldValue(this.sectionName, 'SharingNotice', 1);  // 1 = notice given
    this.cmpApi.setFieldValue(this.sectionName, 'SaleOptOutNotice', 1);         // 1 = notice given
    this.cmpApi.setFieldValue(this.sectionName, 'TargetedAdvertisingOptOutNotice', 1);  // 1 = notice given
    this.cmpApi.setFieldValue(this.sectionName, 'SaleOptOut', this.consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
    this.cmpApi.setFieldValue(this.sectionName, 'TargetedAdvertisingOptOut', this.consentToTargeting ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out
    // this.cmpApi.setFieldValue(this.sectionName, 'SensitiveDataProcessing', this.sensitiveDataConsents);
    this.cmpApi.setFieldValue(this.sectionName, 'KnownChildSensitiveDataConsents', 0); // 0 = not applicable
    this.cmpApi.setFieldValue(this.sectionName, 'MspaCoveredTransaction', 1);  // 1 = yes, 2 = no
    this.cmpApi.setFieldValue(this.sectionName, 'MspaOptOutOptionMode', 1);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
    this.cmpApi.setFieldValue(this.sectionName, 'MspaServiceProviderMode', 2);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)

    // no GPC fields for Virginia
  }

  @Emit('changeViewEvent')
	saveSettingsClick( consentToAll : Boolean ): string {
    this.updateCMP( consentToAll );
    this.cmpApi.fireEvent( "sectionChanged", this.sectionName);
    return 'close'
	}
  
}
